export const addSpacesToCamelCase = (key: string) => {
    return key.replace(/([a-z])([A-Z])/g, "$1 $2").toLowerCase();
};
